import React from 'react'
import { Link } from 'react-router-dom'
import Carousel from '../components/Carousel'
import './Home.css'

const stats = [
  { value: '99.9%', label: 'Uptime SLA' },
  { value: '< 5min', label: 'Deploy Lead Time' },
  { value: '3+', label: 'Cloud Platforms' },
  { value: '100%', label: 'GitOps Driven' },
]

const highlights = [
  {
    icon: '⚡',
    title: 'CI/CD Pipeline Design',
    desc: 'Automated build, test, and deploy workflows using GitHub Actions, ArgoCD, and Jenkins — from commit to production in minutes.',
    color: '#6c63ff',
  },
  {
    icon: '☸️',
    title: 'Kubernetes Orchestration',
    desc: 'Production-grade cluster setup with HPA, RBAC, network policies, and GitOps on EKS, AKS, and GKE.',
    color: '#00c8ff',
  },
  {
    icon: '🌐',
    title: 'Multi-Cloud IaC',
    desc: 'Terraform and Pulumi blueprints for repeatable, auditable cloud infrastructure — AWS, Azure, and GCP.',
    color: '#00e676',
  },
]

export default function Home() {
  return (
    <main>
      {/* ── Hero Carousel ─────────────────────────── */}
      <Carousel />

      {/* ── Stats bar ─────────────────────────────── */}
      <section className="home-stats section--alt">
        <div className="container home-stats__grid">
          {stats.map(s => (
            <div key={s.label} className="home-stats__item">
              <span className="home-stats__value">{s.value}</span>
              <span className="home-stats__label">{s.label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── Value props ───────────────────────────── */}
      <section className="section">
        <div className="container">
          <div className="home-heading">
            <span className="badge">What We Do</span>
            <h2>Cloud Delivery, <span className="text-accent">Engineered Right</span></h2>
            <p>GT Expression specialises in the full DevOps lifecycle — designing and operating the pipelines, clusters, and infrastructure that let your team ship faster and sleep better.</p>
          </div>

          <div className="home-highlights">
            {highlights.map(h => (
              <div key={h.title} className="home-card" style={{ '--card-color': h.color }}>
                <div className="home-card__icon">{h.icon}</div>
                <h3>{h.title}</h3>
                <p>{h.desc}</p>
                <Link to="/services" className="home-card__link">
                  Learn more →
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA banner ────────────────────────────── */}
      <section className="home-cta section--alt">
        <div className="container home-cta__inner">
          <div>
            <h2>Ready to modernise your delivery pipeline?</h2>
            <p>Let's design the CI/CD and Kubernetes architecture your team needs.</p>
          </div>
          <div className="home-cta__btns">
            <Link to="/services" className="btn btn--primary">View Services</Link>
            <Link to="/about" className="btn btn--outline">About Us</Link>
          </div>
        </div>
      </section>
    </main>
  )
}
